<template>
  <VanPopup
    :value="show"
    round
    safe-area-inset-bottom
    position="bottom"
    :close-on-click-overlay="false"
    overlay-class="custom-van-popup-overlay"
    class="custom-van-popup"
  >
    <div class="dispatch-wait">
      <div class="bg"></div>
      <div class="content">
        <div class="title">本次行程用时可能较长</div>
        <div class="desc">
          <span v-if="onTime">
            车辆预计
            <span class="on">{{ onTime }}</span>
            到达上车站
          </span>
          <span v-if="onTime && offTime">，</span>
          <span v-if="offTime">
            <span v-if="!onTime">车辆预计</span>
            <span class="off">{{ offTime }}</span>
            到达下车站
          </span>
          <span v-if="!onTime && !offTime">请合理安排您的出行计划</span>
        </div>
        <div class="route">
          <div class="top">
            <div>
              <img
                src="../../../assets/img-v2/ic_order_wait_stop.png"
                class="stop"
              />
              <img
                src="../../../assets/img-v2/ic_order_wait_bus.png"
                class="bus"
              />
            </div>
            <div v-if="onTime" class="middle">
              <img
                src="../../../assets/img-v2/ic_order_wait_on.png"
                class="icon"
              />
              <div class="text">
                <div class="time">{{ onTime }}</div>
                <div class="label">预计上车时间</div>
              </div>
            </div>
            <div v-if="offTime" class="end">
              <img
                src="../../../assets/img-v2/ic_order_wait_off.png"
                class="icon"
              />
              <div class="text">
                <div class="time time-off">{{ offTime }}</div>
                <div class="label">预计下车时间</div>
              </div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <div class="footer">
          <div class="btn cancel" @click="onCancel">取消行程</div>
          <div class="btn confirm" @click="onConfirm">
            <div>继续等待</div>
            <div class="countdown">（{{ count }}秒后自动确认）</div>
          </div>
        </div>
      </div>
    </div>
  </VanPopup>
</template>

<script>
import { Toast } from "vant";

let intervalId = null;
let guard = null;

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    ticketInfoId: {
      type: [String, Number],
    },
    time: {
      type: Number,
      default: 15,
    },
    onTime: {
      type: String,
      default: "",
    },
    offTime: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      count: 0,
      loading: false,
    };
  },
  watch: {
    show(val) {
      if (val) {
        this.count = this.time;
        this.countdown();
      } else {
        this.clearCountdown();
      }
    },
    loading(val) {
      if (val) {
        Toast.loading({
          message: "操作中",
          duration: 0,
          forbidClick: true,
        });
      } else {
        Toast.clear();
      }
    },
  },
  destroyed() {
    this.clearCountdown();
  },
  methods: {
    countdown() {
      this.clearCountdown();

      intervalId = setInterval(() => {
        this.count--;
        if (this.count <= 0) {
          this.clearCountdown();
          guard && guard.hide();
          this.handlerConfirm(2);
        }
      }, 1000);
    },
    clearCountdown() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    },
    handlerConfirm(userAction) {
      this.$OrderService
        .sureWait({ id: this.ticketInfoId, status: 1, userAction })
        .then(() => {
          this.$emit("close");
        })
        .catch((err) => {
          this.$toast(err.msg || "出错了");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onConfirm() {
      if (this.loading) return;

      guard = this.$dialog.confirm({
        content: `本次出行时长可能会比较久，是否确认继续等待？`,
        confirmText: "确认",
        onOk: () => {
          this.loading = true;
          this.handlerConfirm(1);
        },
      });
      guard.show();
    },
    onCancel() {
      if (this.loading) return;

      this.loading = true;
      this.$OrderService
        .sureWait({ id: this.ticketInfoId, status: 3, userAction: 1 })
        .then(() => {
          this.loading = false;
          this.$emit("close");
        })
        .catch((err) => {
          this.$toast(err.msg || "出错了");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.dispatch-wait {
  padding: 20px;
  position: relative;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 180px;
    background: linear-gradient(180deg, #bddeff 0%, #ffffff 100%),
      linear-gradient(218deg, #d9fff3 0%, rgba(255, 255, 255, 0) 100%);
  }
  .content {
    position: relative;
  }
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #000000;
    line-height: 30px;
  }
  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    margin-top: 12px;
  }
  .on {
    font-family: DINAlternate, DINAlternate;
    font-weight: bold;
    font-size: 20px;
    color: #04b47c;
    line-height: 24px;
  }
  .off {
    font-family: DINAlternate, DINAlternate;
    font-weight: bold;
    font-size: 20px;
    color: #006efa;
    line-height: 24px;
  }
  .footer {
    display: flex;
    align-items: center;
    padding-top: 14px;
  }
  .btn {
    flex: 1;
    height: 48px;
    border-radius: 25px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
  .confirm {
    background: linear-gradient(90deg, #00a7fd 0%, #006efa 100%);
    color: #ffffff;
  }
  .cancel {
    background: #eceff3;
    color: #999999;
    margin-right: 10px;
  }
  .countdown {
    font-weight: 400;
    font-size: 10px;
    color: #ffffff;
    line-height: 14px;
  }

  .route {
    position: relative;
  }

  .top {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 5px;
    display: flex;
    justify-content: space-between;
  }

  .stop {
    width: 44px;
    height: 72px;
  }
  .bus {
    width: 60px;
    height: 33px;
    margin: 0 0 -2px -18px;
  }

  .middle {
    position: relative;
    display: flex;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      bottom: 4px;
      width: 3px;
      height: 23px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px #cbd8e8;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -5px;
      width: 3px;
      height: 9px;
      background: #04b47c;
      border-radius: 0 0 2px 2px;
    }
  }
  .end {
    position: relative;
    display: flex;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      bottom: 4px;
      width: 3px;
      height: 23px;
      background: #ffffff;
      box-shadow: 0px 2px 4px 0px #cbd8e8;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -5px;
      width: 3px;
      height: 9px;
      background: #006efa;
      border-radius: 0 0 2px 2px;
    }
  }
  .icon {
    width: 80px;
    height: 56px;
  }
  .text {
    position: absolute;
    top: 7px;
    left: 10px;
  }
  .time {
    font-family: DINAlternate, DINAlternate;
    font-weight: bold;
    font-size: 24px;
    color: #04b47c;
    line-height: 28px;
    text-shadow: 0px 2px 4px #cbd8e8;
  }
  .time-off {
    color: #006efa;
  }
  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 14px;
    text-shadow: 0px 2px 4px #cbd8e8;
  }
  .line {
    height: 9px;
    background: linear-gradient(90deg, #c0ffeb 0%, #bbdcff 100%);
    border-radius: 5px;
    margin-top: 84px;
  }
}
</style>
